<script>
import TwContainerFullWidth from '../../../components/generic/tw-container-full-width.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'

export default {
  name: 'FundraiserRedirectOldPage',
  components: { TwLoadingSpinner, TwCard, TwContainerFullWidth },
  props: {
    oldId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      Loading: true,
      NotFound: false,
    }
  },
  mounted() {
    this.redirectToFundraiser()
  },
  methods: {
    async redirectToFundraiser() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const fundraiser = await useFundraiserPublicStore().fetchItemByOldId(this.oldId)
        console.log(fundraiser)

        this.Loading = false
        if(fundraiser) {
          this.$router.push({ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug } })
        } else {
          this.NotFound = true
        }
      } catch (e) {
        this.NotFound = true
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container-full-width>
    <tw-card>
      <tw-loading-spinner v-if="Loading" />
      <div v-if="NotFound" class="text-center">
        <h1 class="text-2xl font-bold">
          Page not found
        </h1>
      </div>
    </tw-card>
  </tw-container-full-width>
</template>

<style scoped>

</style>
